import { useState, useCallback } from 'react';
import {
  searchDiagnosticTests,
  addDiagnosticTestToMember,
  removeDiagnosticTestFromMember,
} from '../services/subscriberWalletService';

export const useDiagnosticTests = (currentRole) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [addingTest, setAddingTest] = useState(false);

  const searchTests = useCallback(async (orderId, query) => {
    if (!orderId) return;
    setSearching(true);
    try {
      const response = await searchDiagnosticTests(currentRole, orderId, query);
      if (response?.metadata?.api_status === true) {
        setSearchResults(response.msg?.items || []);
      } else {
        setSearchResults([]);
      }
    } catch {
      setSearchResults([]);
    } finally {
      setSearching(false);
    }
  }, [currentRole]);

  const addTest = useCallback(async (orderId, memberId, testData, showNotification) => {
    setAddingTest(true);
    try {
      const response = await addDiagnosticTestToMember(currentRole, orderId, {
        order_id: orderId,
        member_id: memberId,
        product_id: testData.product_id || '',
        name: testData.name,
        mrp: testData.mrp,
        price: testData.price,
      });
      if (response?.metadata?.api_status === true) {
        showNotification('Test added successfully', 'success');
        return response.msg?.members || null;
      } else {
        throw new Error(response?.msg?.error || 'Failed to add test');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to add test', 'error');
      return null;
    } finally {
      setAddingTest(false);
    }
  }, [currentRole]);

  const removeTest = useCallback(async (orderId, memberId, productId, showNotification) => {
    try {
      const response = await removeDiagnosticTestFromMember(currentRole, orderId, {
        order_id: orderId,
        member_id: memberId,
        product_id: productId,
      });
      if (response?.metadata?.api_status === true) {
        showNotification('Test removed', 'success');
        return response.msg?.members || null;
      } else {
        throw new Error(response?.msg?.error || 'Failed to remove test');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to remove test', 'error');
      return null;
    }
  }, [currentRole]);

  return {
    searchResults,
    searching,
    addingTest,
    searchTests,
    addTest,
    removeTest,
    setSearchResults,
  };
};
